<table class="table">
	<thead>
		<tr class="header-row">
			<th class="header">Categoías</th>
			<th class="header">Nombre</th>
			<th class="header">Elasticsearch</th>
		</tr>
	</thead>
	<ng-container *ngFor="let item of products; let i = index">
		<tr (click)="item.isExpanded = !item.isExpanded">
			<th class="categorie" [ngClass]="{ 'row_background': item.isExpanded }"  colspan="3">{{ item.category.categoryLabel }}
         <img *ngIf="!item.isExpanded" src="assets/images/down.png" alt="arrows">
         <img *ngIf="item.isExpanded" src="assets/images/up.png" alt="arrows">
      </th>
		</tr>

		<tr *ngFor="let prod of item.products; index as i">
			<ng-container *ngIf="item.isExpanded" class="expanded-panel">
				<td><img class="logo" [src]="prod.images[0].imageUrl" alt="product-img" [srcset]="prod.images[0].imageUrl" /></td>
				<td>{{ prod.label }}</td>
				<td class="link" (click)="_modalService.showModalInfo(prod.explain)">
          Ver más
          <img class="arrow" src="assets/images/arrow.png" alt="arrows">
        </td>
			</ng-container>
		</tr>
	</ng-container>
</table>
